module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row g-py-20 g-px-20"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', {
    staticClass: "contract-label"
  }, [_vm._v("Thank you for accepting the new contract!")]), _vm._v(" "), _c('p', {
    staticClass: "contract-description"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.GeneratePdf()
      }
    }
  }, [_vm._v("Click here")]), _vm._v(" "), (_vm.isContractLoading) ? _c('span', [_c('img', {
    staticStyle: {
      "width": "25px"
    },
    attrs: {
      "src": require("../../../static/img/loading.gif")
    }
  })]) : _vm._e(), _vm._v("\n                                    to download a copy for your records.                                    ")]), _vm._v(" "), _c('p', {
    staticClass: "contract-description"
  }, [_vm._v("You can always view and download your current contract in your My Account Page")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-35 g-py-10",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.Login()
      }
    }
  }, [_vm._v("\n                                    Proceed to Home Page "), (_vm.isLoading) ? _c('span', [_c('img', {
    staticStyle: {
      "width": "25px"
    },
    attrs: {
      "src": require("../../../static/img/loading.gif")
    }
  })]) : _vm._e()])])])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-160e0507", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-160e0507"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/ContractAgreementModal.vue
// module id = 463
// module chunks = 3